import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Page } from '../../interfaces/Page/Page';
import { getPage } from '../../api/Page';
import { bodyWidth } from '../../utils/Style';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const PagePage = () => {
  const t = useLocalizedText();

  const { slug } = useParams<string>();

  const [page, setPage] = useState<Page | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getPage(slug ?? '')
      .then(setPage)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      {!!page && (
        <GenericHelmet
          title={page.name}
          meta={{ canonicalURL: `sayfa/${page.slug}` }}
        />
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          py: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        {loading && (
          <CircularProgress color='primary' sx={{ alignSelf: 'center' }} />
        )}
        {!loading && !page && <Typography>{t('page.not_found')}</Typography>}
        {!!page?.body && (
          <Box
            dangerouslySetInnerHTML={{ __html: page.body }}
            sx={{ '& *': { wordBreak: 'break-word' } }}
          />
        )}
      </Box>
    </Box>
  );
};
